module.exports = __webpack_public_path__ + "img/6.2037cf23.png";